import React, { useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogContent,
  Box,
  IconButton,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { styled } from "@mui/material/styles";
const TrainingModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    phone: "",
    email: "",
    agreed: false,
    termsAndConditions: false,
  });

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "agreed" || name === "termsAndConditions" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      if (!formData.phone) {
        toast.error("Please enter a valid phone number", {
          position: "top-right",
        });
        setLoading(false);
        return;
      }
      if(formData.phone.length < 10){
        toast.error("Please enter a valid phone number", {
          position: "top-right",
        });
        setLoading(false);
        return;
      }
       
      // Store form data in localStorage
      localStorage.setItem('userFormData', JSON.stringify(formData));
      
  await axios.post("https://kalisunmarketing.com/api/zapier.php", {
    firstName: formData.firstName,
    email: formData.email,
    phone: formData.phone,
    termsAndConditions: formData.termsAndConditions,
    company: "Khalifwanzo Kalisun Marketing",
    lead_source: "Website Form",
    website: "https://kalisunmarketing.com",
  });
  await axios.post("https://kalisunmarketing.com/api/index.php", formData);
      // Reset form
      setFormData({
        firstName: "",
        phone: "",
        email: "",
        agreed: false,
        termsAndConditions: false,
      });

      // Redirect after a short delay
      setTimeout(() => {
        navigate("/value-video");
        onClose();
      }, 1000);
      
      
    } catch (error) {
      toast.error(`Error submitting form: ${error.message}`, {
        position: "top-right",
      });
    }
    
    setTimeout(() => {
      setLoading(false); // Set loading state back to false after submission
    }, 1000);
  };

  const handlePhoneChange = (value) => {
    if (value) {  
      setFormData((prev) => ({
        ...prev,
        phone: value,
      }));
    }else{
      toast.error("Please enter a valid phone number", {
        position: "top-right",
      });
    }
  }; 


  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          p: 0,
          background: "linear-gradient(145deg, #f6f9fc, #ffffff)",
          overflow: "hidden",
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', // Default Material-UI font stack
        },
      }}
    >
      {/* Toast Container */}
      <ToastContainer />
  
      {/* Header with gradient */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #4e63cb 0%, #1976d2 100%)",
          color: "white",
          p: 3,
          position: "relative",
        }}
      >
        <Typography variant="h6" fontWeight="600" sx={{ fontFamily: 'inherit' }}>
          Get Training Now
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5, fontFamily: 'inherit' }}>
          Fill out the form to get started
        </Typography>
        
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "white",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
  
      <DialogContent sx={{ p: 3 }}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
            fontFamily: 'inherit',
          }}
        >
          {/* Name Field */}
          <Box>
            <Typography
              component="label"
              variant="subtitle2"
              sx={{
                display: "block",
                mb: 1,
                fontWeight: 600,
                color: "black",
                fontFamily: 'inherit',
              }}
            >
              Name <span style={{ color: "#ff5252" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="John Doe"
              variant="outlined"
              size="small"
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f9fafc",
                  "& fieldset": {
                    borderColor: "#e0e0e0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#1976d2",
                  },
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "black", // Black placeholder
                  opacity: 1, // Full opacity
                },
              }}
              inputProps={{
                style: {
                  color: "black", // Black text for input
                },
              }}
            />
          </Box>
  

<Box sx={{
  width: '100%',
  '& .PhoneInput': {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    
    '& input': {
      flex: 1,
      padding: '14px 16px',
      borderRadius: '8px',
      border: '1px solid #e0e0e0',
      backgroundColor: '#f9fafc',
      color: 'black',
      fontSize: '1rem',
      transition: 'all 0.2s ease',
      '&::placeholder': {
        color: '#888',
        opacity: 1,
      },
      '&:focus': {
        outline: 'none',
        borderColor: '#1976d2',
        boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.2)',
      },
    },
    
    '& .PhoneInputCountry': {
      marginRight: '12px',
      position: 'relative',
      
      '& select': {
        padding: '12px 36px 12px 16px',
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
        backgroundColor: '#f9fafc',
        color: 'black',
        fontSize: '1rem',
        appearance: 'none',
        backgroundImage: 'url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e")',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 12px center',
        backgroundSize: '16px',
        cursor: 'pointer',
        '&:focus': {
          outline: 'none',
          borderColor: '#1976d2',
          boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.2)',
        },
      },
      
      '& .PhoneInputCountryIcon': {
        position: 'absolute',
        left: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '20px',
        height: '20px',
        boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
      },
      
      '& .PhoneInputCountrySelectArrow': {
        display: 'none',
      },
    },
  },
}}>
  <Typography
              component="label"
              variant="subtitle2"
              sx={{
                display: "block",
                mb: 1,
                fontWeight: 600,
                color: "black",
                fontFamily: 'inherit',
              }}
            >
              Phone <span style={{ color: "#ff5252" }}>*</span>
            </Typography>
     
              <PhoneInput
                international
                required
                countryCallingCodeEditable={false}
                country={'us'}
                value={formData.phone}
                onChange={handlePhoneChange}
                className="w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="1 (702) 123-4567" // Matching your example format
              />
</Box>

<style>{`
  .PhoneInputCountrySelectDropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 10;
    width: 280px;
    max-height: 300px;
    overflow-y: auto;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 8px 0;
  }
    .react-tel-input>input.form-control {
    width: 100%;
}

  .PhoneInputCountryOption {
    padding: 10px 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: background-color 0.2s ease;
  }
  
  .PhoneInputCountryOption:hover {
    background-color: #f5f5f5;
  }
  
  .PhoneInputCountryOption--highlighted {
    background-color: #e3f2fd;
  }
  .country-name {
    color: black;
  }
  .PhoneInputCountryOption__flag {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    border-radius: 2px;
  }
`}</style>
  
          {/* Email Field */}
          <Box>
            <Typography
              component="label"
              variant="subtitle2"
              sx={{
                display: "block",
                mb: 1,
                fontWeight: 600,
                color: "black",
                fontFamily: 'inherit',
              }}
            >
              Email <span style={{ color: "#ff5252" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
              variant="outlined"
              size="small"
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f9fafc",
                  "& fieldset": {
                    borderColor: "#e0e0e0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#1976d2",
                  },
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "black", // Black placeholder
                  opacity: 1,
                },
              }}
              inputProps={{
                style: {
                  color: "black", // Black text for input
                },
              }}
            />
          </Box>
  
          {/* Terms Checkbox */}
          <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Checkbox
            name="termsAndConditions"
            checked={formData.termsAndConditions}
            onChange={handleChange}
            required
            color="primary"
            size="small"
            sx={{ verticalAlign: 'middle' }}
          />
          <Typography variant="body2" sx={{ 
            fontSize: '0.8rem', 
            fontFamily: 'inherit', 
            color: 'black',
            lineHeight: 1.2
          }}>
            I accept Kali Sun Marketing's 
            <Link href="/terms-and-conditions" color="primary" underline="hover" sx={{ fontFamily: 'inherit' }}>
              Terms and Conditions 
            </Link>{" "}
            & 
            <Link href="/privacy-policy" color="primary" underline="hover" sx={{ fontFamily: 'inherit' }}>
              Privacy Policy
            </Link>
          </Typography>
        </Box>

        <Box sx={{ mt: 1, display: 'flex', alignItems: 'flex-start' }}>
          <Checkbox
            name="agreed"
            checked={formData.agreed}
            onChange={handleChange}
            required
            color="primary"
            size="small"
            sx={{ mt: '2px' }} // Small adjustment for perfect vertical alignment
          />
          <Typography variant="body2" sx={{ 
            fontSize: '0.8rem', 
            fontFamily: 'inherit', 
            color: 'black',
            lineHeight: 1.2 // Adjust line height if needed
          }}>
            Yes, I agree to receive customer care messages from Kali Sun Marketing. By checking this box, I consent to SMS updates from Kali Sun Marketing. Msg frequency varies. Reply END to opt out. Data rates may apply.
          </Typography>
        </Box>
  
          <Box sx={{ mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                py: 1.5,
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 600,
                background: "linear-gradient(135deg, #4e63cb 0%, #1976d2 100%)",
                boxShadow: "none",
                borderRadius: 2,
                fontFamily: 'inherit',
                "&:hover": {
                  background: "linear-gradient(135deg, #3e53bb 0%, #0d65c0 100%)",
                  boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
                },
                "&:disabled": {
                  background: "#e0e0e0",
                },
              }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "Get Started Today"
              )}
            </Button>
          </Box>
  
          {/* Footer Links */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 1.5,
              mt: 2,
              pt: 1,
              borderTop: "1px solid #f0f0f0",
            }}
          >
            <Link 
              href="/privacy-policy"
              color="text.secondary" 
              underline="hover" 
              variant="body2"
              sx={{ fontSize: '0.75rem', fontFamily: 'inherit', color: 'black' }}
            >
              Privacy Policy
            </Link>
            <Box sx={{ 
              width: '1px', 
              backgroundColor: '#e0e0e0',
              my: 0.5
            }} />
            <Link 
              href="/terms-and-conditions" 
              color="text.secondary" 
              underline="hover" 
              variant="body2"
              sx={{ fontSize: '0.75rem', fontFamily: 'inherit', color: 'black' }}
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TrainingModal;
